import { useEffect, useState } from "react";
const useContainerSize = (ref)=>{
    const [size, setSize] = useState({
        width: 0,
        height: 0
    });
    useEffect(()=>{
        const updateSize = ()=>{
            if (ref.current) {
                const { clientWidth, clientHeight } = ref.current;
                setSize({
                    width: clientWidth,
                    height: clientHeight
                });
            }
        };
        updateSize();
        window.addEventListener('resize', updateSize);
        return ()=>window.removeEventListener('resize', updateSize);
    }, [
        ref
    ]);
    return size;
};
export { useContainerSize };
